import { NotesType } from "../enums/enum.enums";

export enum RmdInheritedFlag {
  NON_INHERITED = 1,
  INHERITED
}

export enum RmdStatus {
  UNMET = 1,
  MET
}

//export interface InvestorRmdStatusViewModel {
//  id: number;
//  advisoryFirmId: number;
//  investorId: number;
//  inheritedFlag: RmdInheritedFlag;
//  year: number;
//  status: RmdStatus;
//  notes: string;
//}

//export interface AccountRmdStatusViewModel {
//  id: number;
//  accountId: number;
//  year: number;
//  prevYearFMV: number | null;
//  currYearRMD: number | null;
//  ytdDistribution: number | null;
//  remainingRMD: number | null;
//  status: RmdStatus | null;
//  notes: string;
//}
export interface AccountDistributionsViewModel {
  nextDistDate: string;
  advisoryFirmName: string;
  accountId: number;
  custodianName: string;
  accountNumber: string;
  accountName: string;
  householdName: string;
  startDate: string;
  endDate: string;
  netAmt: number;
  pretaxAmt: number | null;
  fedWithholdingAmt: number | null;
  stateWithholdingAmt: number | null;
  frequency: string;
  assetMoveMethod: string;
  assetMoveType: string;
  instructionNum: number;
  instructionRequestId: string;
  accountValue: number;
  cashBalance: number;
  excessShortfall: number;
  sleeves: AccountDistributionsSleeveDetails[];
}

export interface AccountDistributionsSleeveDetails {
  custodianName: string;
  advisoryFirmName: string;
  accountId: number;
  accountNumber: string;
  accountName: string;
  householdName: string;
  startDate: string;
  endDate: string;
  nextProcessDateWhenLoaded: string;
  netAmt: number;
  pretaxAmt: number | null;
  fedWithholdingAmt: number | null;
  stateWithholdingAmt: number | null;
  frequency: string;
  assetMoveMethod: string;
  assetMoveType: string;
  instructionNum: number;
  instructionRequestId: string;
  accountValue: number;
  cashBalance: number;
  excessShortfall: number;
  boModelDescription: string;
  boAccountIdentifierString: string;
  boCustodialAccountNumber: string;
  boUMAAccountIdentifierString: string;
}

export interface RMDTrackingViewModel {
  advisoryFirmId: number;
  cacheDate: Date;
  nonInherited: RMDTrackingInvestorLevelViewModel[];
  inherited: RMDAccountLevelViewModel[];
}

export interface RMDTrackingInvestorLevelViewModel {
  advisoryFirmId: number;
  investorRmdStatus: InvestorRmdStatusViewModel;
  asOfDate: string;
  inheritedFlag: RmdInheritedFlag;
  investorId: number;
  investorName: string;
  householdId: number;
  householdName: string;
  hasInherited: string;
  hasAnnuity: string;
  fca: string | null;
  advisorIds: number[];
  advisorName: string;
  advisorRepNumber: string;
  secondaryAdvisorName: string;
  holderAge: number | null;
  currYearRMD: number | null;
  ytdDistribution: number | null;
  remainingRMD: number | null;
  cashAvailable: number | null;
  latestNote: string | null;
  totalNotesCount: number;
  repIds: string;
  accounts: RMDAccountLevelViewModel[];
}

export interface RMDAccountLevelViewModel {
  advisoryFirmId: number;
  accountRmdStatus: AccountRmdStatusViewModel;
  custodianProvidedData: boolean;
  accountCloseDate: string;
  accountId: number;
  investorId: number;
  investorName: string;
  householdId: number;
  householdName: string;
  hasNonInherited: string;
  annuityType: string | null;
  fca: string | null;
  advisorIds: number[];
  advisorName: string;
  advisorRepNumber: string;
  secondaryAdvisorName: string;
  asOfDate: string;
  accountNumber: string;
  accountName: string;
  managerAndProduct: string;
  multipleRetirementAccountInd: string;
  holderAge: number | null;
  prevYearFMV: number | null;
  currYearRMD: number | null;
  ytdDistribution: number | null;
  remainingRMD: number | null;
  cashAvailable: number | null;
  monthsRemaining: number | null;
  status: string;
  calculationFactor: number | null;
  inheritedFlag: RmdInheritedFlag;
  periodicPaymentFlag: string;
  rmdListingStatus: string;
  originalIRAOwnerDOD: Date;
  checkWritingCapable: boolean;
  doubleInheritedIRA: boolean;
  latestNote: string | null;
  notes: NoteViewModel[];
  notesCount: number;
  repId: string;
}

export interface InvestorRmdStatusViewModel {
  id: number;
  advisoryFirmId: number;
  investorId: number;
  inheritedFlag: RmdInheritedFlag;
  year: number;
  status: RmdStatus | null;
  notes: string;
}

export interface AccountRmdStatusViewModel {
  id: number;
  accountId: number;
  year: number;
  prevYearFMV: number | null;
  currYearRMD: number | null;
  ytdDistribution: number | null;
  remainingRMD: number | null;
  status: RmdStatus | null;
  notes: string;
  doubleInheritedIRA: boolean | null;
}

export interface HouseholdRmdFcaViewModel {
  advisoryFirmId: number;
  householdId: number;
  fca: string | null;
}

export interface NoteViewModel {
  id: number;
  notes: string;
  objectId: number;
  notesType: NotesType;
  dateCreated: Date;
  noteStatus: string;
  dateChanged?: Date;
  systemLoginCreated: string;
  systemLoginChanged: string;
  isDeleted: boolean;
  isPrivate: boolean;
  preserve: boolean;
  fullName: string;
  impersonatorLoginCreated: string;
}

